import script from "./SignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=6ee96deb&scoped=true&lang=css"
import "./SignUp.vue?vue&type=style&index=1&id=6ee96deb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee96deb"]])

export default __exports__